import { Link } from "react-router-dom";

function EventItem({ year, title, event_date, location, link, isLast }) {
  return (
    <div className="py-8 flex flex-col md:flex-row gap-6 pb-6">
      {/* YEAR */}
      <div className="md:w-2/12 text-center">
        {year && <h1 className="text-3xl font-semibold">{year}</h1>}
      </div>

      {/* INFO */}
      <div className="md:w-10/12">
        <h3 className="text-lg font-medium">{title}</h3>
        <p className="mt-1 text-gray-700">
          {event_date} <br /> {location}
        </p>

        <Link
          to={link}
          className="mt-2 inline-block text-blue-600 hover:underline"
        >
          Details
        </Link>
      </div>
    </div>
  );
}

export default EventItem;
